import Image from "next/image";
import Link from "@/components/ui/Link";
import { sanitizeHTML } from "@/lib/utils";
import { getReadableImageUrl } from "@/lib/directus";

interface BookPrivateConsultationData {
  anchor_title?: string;
  heading?: {
    title?: string;
  };
  text?: {
    text?: string;
  };
  image?: {
    alt?: string;
    image_file?: {
      image?: {
        id?: string;
        filename_download?: string;
      };
    };
  };
  buttons?: {
    menu_items_id?: {
      label?: string;
      href?: string;
    };
  }[];
}

export const fields = [
  "anchor_title",
  "heading.title",
  "text.text",
  "image.alt",
  "image.image_file.image.id",
  "image.image_file.image.filename_download",
  "buttons.menu_items_id.label",
  "buttons.menu_items_id.href",
] as const;

export default function BookPrivateConsultation({ data }: { data?: BookPrivateConsultationData }) {
  const imageUrl = getReadableImageUrl(
    data?.image?.image_file?.image?.id || "",
    data?.image?.image_file?.image?.filename_download || ""
  );

  const sectionId = (data?.anchor_title || 'BookPrivateConsultation')
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-_]/g, '')
    .replace(/-{2,}/g, '-');

  return (
    <section id={sectionId} className="BookPrivateConsultation bg-[#635B56] py-[3.75rem]">
      <div className="container">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="flex flex-col justify-center py-6 lg:py-16 lg:pl-16 lg:pr-14 order-2 lg:order-1">
          {data?.heading?.title && (
            <h2 className="font-freightBig text-[2.25rem] font-normal leading-[3rem] text-white mb-6">
              {data.heading.title}
            </h2>
          )}
          {data?.text?.text && (
            <div
              className="font-sans text-base font-normal leading-7 text-white/90 [&>p]:mb-4 [&>p:last-child]:mb-0"
              dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
            />
          )}
          {data?.buttons && data.buttons.length > 0 && (
            <div className="flex flex-wrap gap-4 mt-8">
              {data.buttons.map((btn, index) => (
                btn?.menu_items_id?.href && (
                  <Link
                    key={index}
                    className="btn"
                    href={btn.menu_items_id.href}
                  >
                    {btn.menu_items_id.label}
                  </Link>
                )
              ))}
            </div>
          )}
        </div>
        <div className="relative min-h-[300px] lg:min-h-0 order-1 lg:order-2">
          {data?.image && imageUrl && (
            <Image
              src={imageUrl}
              alt={data.image.alt || ""}
              fill
              quality={95}
              loading="lazy"
              className="object-cover"
              sizes="(min-width: 1024px) 50vw, 100vw"
            />
          )}
        </div>
      </div>
      </div>
    </section>
  );
}
